module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAdElEQVR4AWIYFOCDj8/L997e/2mM9+F0AKD9OsAAGIZiMLz7n6e73wQEEEpfVv4QjJoPy2Y6MNEIeM7E9wcAwKt71RrA1xsAydPcdKYJUNcBwEauBwAID1xYQQHACgCwAlYQvqCrBnAA/BpQ6OzPaXhX1PIBzA8+LKqkSO8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/usericon2.png
// module id = XbfC
// module chunks = 1